import { render, staticRenderFns } from "./RenegociacaoList.vue?vue&type=template&id=72d2a5fc&scoped=true&"
import script from "./RenegociacaoList.vue?vue&type=script&lang=js&"
export * from "./RenegociacaoList.vue?vue&type=script&lang=js&"
import style0 from "./RenegociacaoList.vue?vue&type=style&index=0&id=72d2a5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2a5fc",
  null
  
)

export default component.exports